import React from 'react';

export default function FeatureCards() {
  return (
    <div className="mt-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-lg hover:shadow-xl transition">
          <h3 className="text-xl font-bold text-[var(--color-primary)] mb-4">Gerçek Zamanlı İzleme</h3>
          <p className="text-[var(--color-black)]">
            Enerji üretiminizi ve tüketiminizi anlık olarak takip edin.
          </p>
        </div>
        <div className="bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-lg hover:shadow-xl transition">
          <h3 className="text-xl font-bold text-[var(--color-primary)] mb-4">Akıllı Analiz</h3>
          <p className="text-[var(--color-black)]">
            Yapay zeka destekli analizlerle performansınızı optimize edin.
          </p>
        </div>
        <div className="bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-lg hover:shadow-xl transition">
          <h3 className="text-xl font-bold text-[var(--color-primary)] mb-4">Kolay Entegrasyon</h3>
          <p className="text-[var(--color-black)]">
            Mevcut sistemlerinize hızlıca entegre edin ve kullanmaya başlayın.
          </p>
        </div>
      </div>
    </div>
  );
} 